"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Expandable = exports.CollapsibleSidebar = exports.useSidebarContext = exports.SidebarContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _withTheme = require("../../wrappers/with-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SidebarContext = /*#__PURE__*/_react["default"].createContext({});

exports.SidebarContext = SidebarContext;

var useSidebarContext = function useSidebarContext() {
  return _react["default"].useContext(SidebarContext);
};

exports.useSidebarContext = useSidebarContext;
var InitialState = {
  Comp: null,
  top: 0,
  compProps: {},
  open: true,
  transitioning: false
};

var InitState = function InitState(open) {
  return _objectSpread(_objectSpread({}, InitialState), {}, {
    open: open
  });
};

var Reducer = function Reducer(state, action) {
  var type = action.type,
      payload = _objectWithoutProperties(action, ["type"]);

  switch (type) {
    case "update-state":
      return _objectSpread(_objectSpread({}, state), payload);

    default:
      return state;
  }
};

var Shift = {
  value: 0.25,
  unit: "rem"
};

var Toggle = function Toggle(_ref) {
  var togglePosition = _ref.togglePosition,
      position = _ref.position,
      doToggle = _ref.doToggle,
      open = _ref.open,
      dir = _ref.dir,
      theme = _ref.theme,
      padding = _ref.padding;

  switch (togglePosition) {
    case "middle":
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "\n            rounded z-10 py-1 absolute hover:".concat(theme.textInfo, "\n            ").concat(theme.sidebarBg, " cursor-pointer flex flex-col\n            hover:").concat(theme.menuBg, " transition ").concat(position, "-0\n          "),
        style: {
          transform: "translateY(-50%)",
          top: "50%"
        },
        onClick: doToggle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "fa fa-caret-left text-2xl pl-1 pr-2",
        style: {
          transform: "scaleX(".concat((open ? 1 : -1) * dir),
          transition: "transform 500ms"
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "fa fa-caret-left text-2xl pl-1 pr-2",
        style: {
          transform: "scaleX(".concat((open ? 1 : -1) * dir),
          transition: "transform 500ms ease 250ms"
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "fa fa-caret-left text-2xl pl-1 pr-2",
        style: {
          transform: "scaleX(".concat((open ? 1 : -1) * dir),
          transition: "transform 500ms ease 500ms"
        }
      }));

    default:
      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: doToggle,
        style: {
          transform: "translateX(".concat(open ? "-".concat(padding, "px") : "0px", ")"),
          transition: "all 500ms"
        },
        className: "\n            ".concat(theme.sidebarBg, " py-1 px-2\n            hover:").concat(theme.menuBg, " hover:").concat(theme.textInfo, "\n            z-10 cursor-pointer\n            absolute ").concat(position, "-0 top-0\n          ")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "fa fa-caret-left text-lg",
        style: {
          transform: "scaleX(".concat((open ? 1 : -1) * dir, ")"),
          transition: "transform 500ms"
        }
      }));
  }
};
/*
<div className={ `
    rounded bg-white z-10 py-1 absolute hover:${ theme.textInfo }
    ${ theme.sidebarBg } cursor-pointer flex flex-col
    hover:${ theme.menuBg } transition ${ position }-0
  ` }
  style={ {
    transform: `translateY(-50%)`,
    top: "50%"
  } }
  onClick={ doToggle }>

  <div className="fa fa-caret-left text-2xl pl-1 pr-2"
    style={ {
      transform: `scaleX(${ (open ? 1 : -1) * dir }`,
      transition: "transform 500ms"
    } }/>
  <div className="fa fa-caret-left text-2xl pl-1 pr-2"
    style={ {
      transform: `scaleX(${ (open ? 1 : -1) * dir }`,
      transition: "transform 500ms ease 250ms"
    } }/>
  <div className="fa fa-caret-left text-2xl pl-1 pr-2"
    style={ {
      transform: `scaleX(${ (open ? 1 : -1) * dir }`,
      transition: "transform 500ms ease 500ms"
    } }/>
</div>
*/


var CollapsibleSidebar = function CollapsibleSidebar(_ref2) {
  var _ref4;

  var placeBeside = _ref2.placeBeside,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 320 : _ref2$width,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? 8 : _ref2$padding,
      children = _ref2.children,
      _ref2$startOpen = _ref2.startOpen,
      startOpen = _ref2$startOpen === void 0 ? true : _ref2$startOpen,
      _ref2$position = _ref2.position,
      position = _ref2$position === void 0 ? "left" : _ref2$position,
      _ref2$customTheme = _ref2.customTheme,
      customTheme = _ref2$customTheme === void 0 ? {} : _ref2$customTheme,
      togglePosition = _ref2.togglePosition,
      _ref2$showToggle = _ref2.showToggle,
      showToggle = _ref2$showToggle === void 0 ? true : _ref2$showToggle,
      _ref2$shift = _ref2.shift,
      shift = _ref2$shift === void 0 ? Shift : _ref2$shift;

  var _React$useReducer = _react["default"].useReducer(Reducer, startOpen, InitState),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var open = state.open,
      transitioning = state.transitioning;

  var setOpen = _react["default"].useCallback(function (open) {
    dispatch({
      type: "update-state",
      open: open,
      transitioning: true
    });
    timeout.current = setTimeout(dispatch, 500, {
      type: "update-state",
      transitioning: false
    });
  }, []);

  var dir = position === "left" ? 1 : -1;

  var timeout = _react["default"].useRef();

  _react["default"].useEffect(function () {
    return function () {
      return clearTimeout(timeout.current);
    };
  }, []);

  var doToggle = _react["default"].useCallback(function (e) {
    setOpen(open > 0 ? open - 1 : 1);
  }, [open, setOpen]);

  var _React$useState = _react["default"].useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      node = _React$useState2[0],
      setNode = _React$useState2[1];

  var extendSidebar = _react["default"].useCallback(function (_ref3) {
    var Comp = _ref3.Comp,
        _ref3$top = _ref3.top,
        top = _ref3$top === void 0 ? 0 : _ref3$top,
        _ref3$compProps = _ref3.compProps,
        compProps = _ref3$compProps === void 0 ? {} : _ref3$compProps;
    if (open === 0) return;
    setOpen(2);
    var sidebarTop = node ? node.getBoundingClientRect().top : 0;

    if (typeof top === "string") {
      top = "calc(".concat(top, " - ").concat(sidebarTop, "px)");
    } else {
      top -= sidebarTop;
    }

    dispatch({
      type: "update-state",
      Comp: Comp,
      compProps: compProps,
      top: top
    });
  }, [open, setOpen, node]);

  var passCompProps = _react["default"].useCallback(function (compProps) {
    if (open !== 2) return;
    dispatch({
      type: "update-state",
      compProps: compProps
    });
  }, [open]);

  var closeExtension = _react["default"].useCallback(function () {
    if (open !== 2) return;
    setOpen(1);
  }, [open, setOpen]);

  var contextValue = _react["default"].useMemo(function () {
    return _objectSpread(_objectSpread({}, state), {}, {
      extendSidebar: extendSidebar,
      passCompProps: passCompProps,
      closeExtension: closeExtension,
      open: open
    });
  }, [extendSidebar, passCompProps, closeExtension, state, open]);

  var theme = _objectSpread(_objectSpread({}, (0, _withTheme.useTheme)()), customTheme);

  var styleWidth = "calc(".concat((width - padding * 2) * open, "px - ").concat(open > 1 ? "".concat(shift.value * (open - 1)).concat(shift.unit) : "0rem", ")");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute ".concat(position, "-0 top-0 bottom-0 z-30"),
    style: {
      padding: "".concat(padding, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(SidebarContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full relative",
    style: {
      transition: "width 500ms",
      width: styleWidth
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute top-0 bottom-0",
    style: (_ref4 = {}, _defineProperty(_ref4, position, "calc(100% + ".concat(padding, "px - ").concat(open ? 0 : padding, "px)")), _defineProperty(_ref4, "transition", "".concat(position, " 500ms")), _ref4)
  }, placeBeside, !showToggle ? null : /*#__PURE__*/_react["default"].createElement(Toggle, {
    togglePosition: togglePosition,
    position: position,
    doToggle: doToggle,
    open: open,
    dir: dir,
    theme: theme,
    padding: padding
  })), /*#__PURE__*/_react["default"].createElement(ExtendedSidebar, {
    top: state.top,
    open: open === 2,
    transitioning: transitioning,
    width: width,
    padding: padding
  }, typeof state.Comp !== "function" ? state.Comp : /*#__PURE__*/_react["default"].createElement(state.Comp, state.compProps)), /*#__PURE__*/_react["default"].createElement(Expandable, {
    open: open,
    ref: setNode,
    transitioning: transitioning,
    width: width,
    padding: padding
  }, children))));
};

exports.CollapsibleSidebar = CollapsibleSidebar;

var Expandable = /*#__PURE__*/_react["default"].forwardRef(function (_ref5, ref) {
  var open = _ref5.open,
      transitioning = _ref5.transitioning,
      width = _ref5.width,
      padding = _ref5.padding,
      children = _ref5.children,
      _ref5$heightFull = _ref5.heightFull,
      heightFull = _ref5$heightFull === void 0 ? true : _ref5$heightFull;
  var theme = (0, _withTheme.useTheme)();
  var hFull = heightFull ? "h-full" : "";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(hFull, " w-full"),
    ref: ref,
    style: {
      overflow: open && !transitioning ? "visible" : "hidden"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(hFull, " scrollbar-sm overflow-y-auto"),
    style: {
      width: "".concat(width - padding * 2, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n          absolute top-0 right-0 bottom-0 left-0 pointer-events-none z-10\n          ".concat(open ? "opacity-0" : "opacity-100", " ").concat(theme.sidebarBg, "\n        "),
    style: {
      transition: "opacity 500ms"
    }
  }), children));
});

exports.Expandable = Expandable;

var ExtendedSidebar = function ExtendedSidebar(_ref6) {
  var width = _ref6.width,
      padding = _ref6.padding,
      open = _ref6.open,
      _ref6$top = _ref6.top,
      top = _ref6$top === void 0 ? 0 : _ref6$top,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["width", "padding", "open", "top", "children"]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute",
    style: {
      width: "".concat(open ? width - padding * 2 : 0, "px"),
      left: "calc(".concat(width - padding * 2, "px - 0.25rem)"),
      transition: "width 500ms",
      top: typeof top === "string" ? top : "".concat(top, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(Expandable, _extends({}, props, {
    heightFull: false,
    width: width,
    padding: padding,
    open: open
  }), children));
};